import { useField } from "formik";
import FormGroup from "../formGroup";
import FormLabel from "../formLabel";
import FormTextField from "../textField";
import { FormFieldConfig } from "../types";
import FieldRenderType from "shared/form/renderer/enums/FieldRenderType";
import { getValueForReadOnlyFieldForStaticForm } from "shared/form/util";
import { useFormContextData } from "shared/form/context";
import FormOverwriteField from "../overwriteField";
import { isEmpty } from "shared/utils";

function FormUrlField(props: FormFieldConfig) {
  const formContextData = useFormContextData();
  const [{ value }] = useField({ name: props.name, validate: props.validate });

  if (formContextData.isReadOnly || (props.disabled && value)) {
    return (
      <FormGroup className={props.className} fullWidth={props.fullWidth} indented={props.indented}>
        <FormLabel label={props.label} required={props.required} infoLabel={props.infoLabel} />
        {getValueForReadOnlyFieldForStaticForm({ renderType: FieldRenderType.URL, value: value })}
        {!isEmpty(props.conflictValue) && (
          <FormOverwriteField forFieldName={props.name} disabled={props.disabled} className="mt-16" />
        )}
      </FormGroup>
    );
  }

  return (
    <FormTextField
      name={props.name}
      label={props.label}
      infoLabel={props.infoLabel}
      disabled={props.disabled}
      required={props.required}
      placeholder={props.placeholder}
      validate={props.validate}
      className={props.className}
      fullWidth={props.fullWidth}
      conflictValue={props.conflictValue}
      indented={props.indented}
      enableFieldReset={props.enableFieldReset}
      fixedInitialValueOnReset={props.fixedInitialValueOnReset}
    />
  );
}

export default FormUrlField;
